import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { ShippingFeesInterface } from 'common/types/entities/ShippingFeesInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export const createShippingFees = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): ShippingFeesInterface => {
  return {
    ...generateBaseEntity(EntityTypeEnum.ShippingFees, parentId, masterBlockId),
    fontSize: 16,
    padding: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  }
}
